var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({staticClass:"ai-lazy-img",attrs:{"data-src":_vm.src,"src":_vm.currentSrc}},'img',_vm.config,false))
}
var staticRenderFns = []

export { render, staticRenderFns }